var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex items-center px-2 py-1 rounded-md text-sm font-medium leading-5",class:_vm.color},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }